import axios from "axios";
import React, { useEffect, useState } from "react";

const DropdownComponent = ({
  selectedCompany,
  setSelectedCompany,
  selectedYear,
  setSelectedYear,
  selectedQuarter,
  setSelectedQuarter,
}) => {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "row",
      gap: "20px",
    },
    dropdownContainer: {
      marginBottom: "8px",
    },
    label: {
      marginBottom: "8px",
      fontWeight: "bold",
    },
    select: {
      width: "100%",
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
    },
  };

  const baseurl = `${process.env.REACT_APP_GET_COMPANY_URL}`;
  const [companyList, setCompanyList] = useState([]);
  const [years, setYears] = useState([]);
  const [quarters, setQuarters] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCompanies();
  }, []);

  const getCompanies = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(baseurl);
      setCompanyList(data?.all_companies || []);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  // Handle Company Selection
  const handleCompanyChange = (e) => {
    const selected = e.target.value;
    setSelectedCompany(selected);
    setSelectedYear(""); // Reset year when company changes
    setSelectedQuarter(""); // Reset quarter when company changes

    const companyData = companyList.find(
      (company) => company.company_name === selected
    );

    if (companyData) {
      const availableYears = companyData.years.map((yearObj) => yearObj.year);
      setYears(availableYears);
    } else {
      setYears([]);
    }
  };

  // Handle Year Selection
  const handleYearChange = (e) => {
    const selected = e.target.value;
    setSelectedYear(selected);
    setSelectedQuarter(""); // Reset quarter when year changes

    const companyData = companyList.find(
      (company) => company.company_name === selectedCompany
    );

    if (companyData) {
      const yearData = companyData.years.find(
        (yearObj) => yearObj.year.toString() === selected
      );
      setQuarters(yearData ? yearData.reporting_periods : []);
    } else {
      setQuarters([]);
    }
  };

  return (
    <div style={styles.container}>
      {/* Company Dropdown */}
      <div style={styles.dropdownContainer}>
        <label style={styles.label}>Company</label>
        <select
          style={styles.select}
          value={selectedCompany}
          onChange={handleCompanyChange}
        >
          <option value="" disabled>
            {loading ? "Loading..." : "Select Company"}
          </option>
          {!loading &&
            companyList.map((item, index) => (
              <option value={item.company_name} key={index}>
                {item.company_name}
              </option>
            ))}
        </select>
      </div>

      {/* Year Dropdown */}
      <div style={styles.dropdownContainer}>
        <label style={styles.label}>Year</label>
        <select
          style={styles.select}
          value={selectedYear}
          onChange={handleYearChange}
          disabled={!selectedCompany}
        >
          <option value="" disabled>
            Select Year
          </option>
          {years.map((year, index) => (
            <option value={year} key={index}>
              {year}
            </option>
          ))}
        </select>
      </div>

      {/* Quarter Dropdown */}
      <div style={styles.dropdownContainer}>
        <label style={styles.label}>Quarter</label>
        <select
          style={styles.select}
          value={selectedQuarter}
          onChange={(e) => setSelectedQuarter(e.target.value)}
          disabled={!selectedYear}
        >
          <option value="" disabled>
            Select Quarter
          </option>
          {quarters.map((quarter, index) => (
            <option value={quarter} key={index}>
              {quarter}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DropdownComponent;
